<template>
    <div>
        <v-text-field
            v-model="valeur"
            :label="label"
            :loading="loading"
            outlined
            dense
            readonly
            clearable
            @click:clear="clear"
            @click="dialog = true"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
        ></v-text-field>

        <v-dialog
            v-model="dialog"
            max-width="500"
            scrollable
        >
            <v-card>
                <v-toolbar flat dense dark color="teal">
                    <v-toolbar-title>{{ $t('common.state') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid>
                        <v-list dense>
                            <v-list-group
                                v-for="(workFlow, index) in workFlows"
                                :key="`workFlow-${index}`"
                                :value="workFlow.steps.some(step => step.id === value)"
                                no-action
                            >
                                <template v-slot:activator>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="workFlow.name"></v-list-item-title>
                                    </v-list-item-content>
                                </template>

                                <v-list-item
                                    v-for="(step, index) in workFlow.steps.filter(e => exceptFinal ? e.state !== 'FINAL': true)"
                                    :key="`step-${index}`"
                                    @click="save(workFlow, step)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title v-text="step.name"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-group>
                        </v-list>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        depressed
                        color="teal"
                        dark
                        @click="dialog = false"
                    >
                        {{ $t('common.close') }}
                        <v-icon right>mdi-close</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <input type="hidden">
    </div>
</template>

<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";
import axios from "axios";
export default {
    name: 'StrAllStepSelect',
    props: {
        value: [Number],
        label: String,
        byName: Boolean,
        exceptFinal: Boolean,
    },
    setup(props, {emit}) {
        const {inputColor, backgroundColor, dialog, loading} = useSharedData();
        dialog.value = false;
        const valeur = ref(null);
        const workFlows = ref([]);
        function findAll() {
            loading.value = true;
            axios.get('/validationWorkFlows').then(response => {
                workFlows.value = response.data;
            }).finally(() => {
                loading.value = false;
            })
        }
        function save(workFlow, stp) {
            emit('input', props.byName ? stp.name : stp.id);
            valeur.value = `${workFlow.name} - ${stp.name}`;
            dialog.value = false;
        }

        watch(() => props.value, () => {
            if(!props.value)
                clear();
        });

        function clear() {
            emit('input', null);
            valeur.value = null;
        }
        onMounted(() => {
            findAll();
        })
        return {
            inputColor,
            backgroundColor,
            dialog,
            loading,
            valeur,
            workFlows,
            save,
            clear,
        }
    },
}
</script>